'use strict';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||!1;descriptor.configurable=!0;if('value'in descriptor)descriptor.writable=!0;Object.defineProperty(target,descriptor.key,descriptor)}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor}}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value}catch(error){reject(error);return}if(info.done){resolve(value)}else{return Promise.resolve(value).then(function(value){step('next',value)},function(err){step('throw',err)})}}return step('next')})}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function')}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called')}return call&&(typeof call=='object'||typeof call=='function')?call:self}function _inherits(subClass,superClass){if(typeof superClass!='function'&&superClass!==null){throw new TypeError('Super expression must either be null or a function, not '+typeof superClass)}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass}

const _=require('pulsar-utils/dist-es6/_');
const BaseOrganizationProfileController=require('../../../../dist-es6/client/features/organizationProfile/baseOrganizationProfileController');
const{AvailableDataRetentionPeriods:AvailableDataRetentionPeriods}=require('../../../../dist-es6/shared/domain/dataRetentionPeriod');let


OrganizationProfileController=function(_BaseOrganizationProf){_inherits(OrganizationProfileController,_BaseOrganizationProf);_createClass(OrganizationProfileController,null,[{key:'$inject',get:function()
{
return['$scope','$modal','$state','$timeout','breadcrumbsService','userService','socketService','uncaughtErrorHandler'];
}}]);

function OrganizationProfileController($scope,$modal,$state,$timeout,breadcrumbsService,userService,socketService,uncaughtErrorHandler){_classCallCheck(this,OrganizationProfileController);var _this=_possibleConstructorReturn(this,
_BaseOrganizationProf.call(this,$state,$timeout,userService,socketService,uncaughtErrorHandler));

_this._$modal=$modal;

if(_.get(userService,'currentUser.isPrimary')!==!0){
$state.go('fdc.features.profile');
return _possibleConstructorReturn(_this);
}

breadcrumbsService.startTrail('Organization Profile');

$scope.$watch('controller.initialLoadComplete',function(isComplete){
if(!isComplete)
return;

_this._updateDataRetentionLabel();
});

_this.availableDataRetentionPeriods=AvailableDataRetentionPeriods;return _this;
}OrganizationProfileController.prototype.

_reloadProfileDataAndRetentionSettings=function(){var ref=_asyncToGenerator(function*(){var _this2=this;
yield this._reloadProfileData();
this._$timeout(function(){
_this2._updateDataRetentionLabel();
});
});function _reloadProfileDataAndRetentionSettings(){return ref.apply(this,arguments)}return _reloadProfileDataAndRetentionSettings}();OrganizationProfileController.prototype.

_updateDataRetentionLabel=function _updateDataRetentionLabel(){
const currentRetentionPeriod=_.find(this.availableDataRetentionPeriods,{value:this.dataRetentionPeriodMs});

this._currentRetentionPeriod=currentRetentionPeriod;
this._currentDataRetentionLabel=_.exists(currentRetentionPeriod.numWeeks)?
`${currentRetentionPeriod.numWeeks} weeks (${currentRetentionPeriod.label})`:
currentRetentionPeriod.label;
};OrganizationProfileController.prototype.

editDataRetentionSetting=function editDataRetentionSetting(){var _this3=this;
let modalInstance=this._$modal.open({
templateUrl:'/templates/features/organizationProfile/components/editDataRetentionPeriodModalView',
controller:'EditDataRetentionPeriodModalController as controller',
resolve:{
selectedRetentionPeriod:function(){return _this3._currentRetentionPeriod},
availableDataRetentionPeriods:function(){return _this3.availableDataRetentionPeriods},
onRetentionPeriodUpdated:function(){return _this3._reloadProfileDataAndRetentionSettings.bind(_this3)}}});


};_createClass(OrganizationProfileController,[{key:'currentDataRetentionLabel',get:function()

{
return this._currentDataRetentionLabel;
}}]);return OrganizationProfileController}(BaseOrganizationProfileController);


module.exports=OrganizationProfileController;
//# sourceMappingURL=organizationProfileController.js.map
